import { render, staticRenderFns } from "./WarrantDetails.vue?vue&type=template&id=37f13acc&scoped=true&"
import script from "./WarrantDetails.js?vue&type=script&lang=js&"
export * from "./WarrantDetails.js?vue&type=script&lang=js&"
import style0 from "./WarrantDetails.vue?vue&type=style&index=0&id=37f13acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f13acc",
  null
  
)

export default component.exports